export const theme = {
    primary: {
        grayColor: '#C4C4C4',
        color: '#5D5CFF',}}